import ReactDOM from 'react-dom'
import { HashRouter as Router } from 'react-router-dom'
import { Provider } from 'react-redux'
import { ConfigProvider } from 'antd'
import zhCN from 'antd/lib/locale/zh_CN'
import 'antd/dist/antd.less'
import reportWebVitals from './reportWebVitals'
import store from './redux/store'
import App from './App'
import './index.less'
import './assets/css/reset.css'

ConfigProvider.config({ theme: { primaryColor: 'red' } })

ReactDOM.render(
  <ConfigProvider
    theme={{
      token: {
        colorPrimary: '#FA622F',
      },
    }}
    locale={zhCN}
  >
    <Provider store={store}>
      <Router>
        <App />
      </Router>
    </Provider>
  </ConfigProvider>,

  document.getElementById('root')
)

reportWebVitals()
